const COMPANY_ID_KEY = "companyId";

/**
 * Get the company ID from localStorage
 * @returns The company ID as a number, or null if not set
 */
export const getCompanyId = (): number | null => {
  const companyIdStr = localStorage.getItem(COMPANY_ID_KEY);

  if (!companyIdStr) {
    return null;
  }

  const companyId = parseInt(companyIdStr, 10);

  if (isNaN(companyId)) {
    console.warn("Invalid company ID in localStorage");
    return null;
  }

  return companyId;
};

/**
 * Set the company ID in localStorage
 * @param companyId - The company ID to store
 */
export const setCompanyId = (companyId: number): void => {
  if (companyId <= 0) {
    console.error("Invalid company ID: must be a positive number");
    return;
  }

  localStorage.setItem(COMPANY_ID_KEY, companyId.toString());
};

/**
 * Remove the company ID from localStorage
 */
export const removeCompanyId = (): void => {
  localStorage.removeItem(COMPANY_ID_KEY);
};

/**
 * Check if a company ID is set
 * @returns True if a company ID exists in localStorage
 */
export const hasCompanyId = (): boolean => {
  return getCompanyId() !== null;
};

/**
 * Get the company ID or throw an error if not set
 * @returns The company ID as a number
 * @throws Error if company ID is not set
 */
export const getCompanyIdOrThrow = (): number => {
  const companyId = getCompanyId();

  if (companyId === null) {
    throw new Error("Company ID not set in localStorage");
  }

  return companyId;
};
